<template>
  <div class="privacy-container responsive-p">
    <NavigationBar :items="navItems" />
    <div class="content-wrapper">
      <div class="wysiwyg" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { getItem } from '@/api/cms/query'

import NavigationBar from '@/components/NavigationBar'

export default {
  name: 'PrivacyPolicy',
  components: {
    NavigationBar,
  },
  setup() {
    const { t } = useI18n()

    const content = ref('')
    const title = ref('')

    onMounted(async () => {
      const privacyPolicy = await getItem('privacy_policy')
      if (privacyPolicy) {
        title.value = privacyPolicy?.translations?.title
        content.value = privacyPolicy?.translations?.content
      }
    })
    const navItems = computed(() => [
      {
        name: t('menu.home'),
        path: '/'
      },
      {
        name: title.value,
      }
    ])

    return {
      t,
      content,
      navItems,
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-container {
  display: flex;
  flex-direction: column;
  padding-top: 56px;
  position: relative;
}

.title {
  font-size: 24px;
  font-weight: bold;
}

.content-wrapper {
  margin-top: 24px;
}

::v-deep(.wysiwyg img) {
  max-width: 100%;
  height: auto;
}
</style>
